import { z } from 'zod';

// Schemas shared by many contracts.

/** A point in time: an ISO string on the wire, a Date for the caller. Handlers return `date.toISOString()`. */
export const timestamp = z.iso.datetime().transform((value) => new Date(value));
